import React, { useEffect, useState } from "react";
import CustomSnackbar from "../../newTestPreo/components/snackbar/Snackbar";
import AuthWrapper1 from "../../newTestPreo/pages/authentication/AuthWrapper1";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Wrapper from "../../newTestPreo/pages/studentRegistration/Wrapper";
import OtpComp from "../../newTestPreo/pages/studentRegistration/OtpComp";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function EventRegistrationUi() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qrCode = queryParams.get("code");
  const [isdCodeList, setIsdCodeList] = useState([]);
  const [isdCode, setIsdCode] = useState(91);
  const [mobile, setMobile] = useState(null);
  const [name, setName] = useState("");
  const [showotp, setshowotp] = useState(false);
  const [otp, setOtp] = useState(null);
  const [seconds, setSeconds] = useState(0);
  const [isPlaying, setisPlaying] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [errors, setErrors] = useState(false);
  const [showOtpcomp, setShowOtpComp] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // Fetch Countries
  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}countries`)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = [...data].sort(
          (a, b) => a.phone_code - b.phone_code
        );
        const uniqueArray = sortedData.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.phone_code === obj.phone_code)
        );

        setIsdCodeList(uniqueArray);
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  //   genrate otp

  // Generate OTP
  const handleGenrateOtp = async () => {
    if (name === "") {
      showSnackbar("Plese Enter Name", "error");
      return;
    }
    const payload = {
      mobile: mobile || null,
      mobile_country_code: isdCode,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}studentsignup/generating/otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.status == 200 || response.ok) {
        showSnackbar("OTP send  successfully");
        setshowotp(true);
        setSeconds(300);
        setisPlaying(true);
        setShowReset(false);
        setShowOtpComp(true);
      } else if (response.status === 400) {
        showSnackbar("Enter Valid Mobile Number", "error");
      } else if (response.status === 409) {
        showSnackbar("Already exisitng this number!!", "error");
      } else {
        showSnackbar("Error send OTP", "error");
      }
    } catch (error) {
      showSnackbar("Error send OTP", "error");
    }
  };

  // Otp change
  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setErrors({ ...errors, otp: !e.target.value });
  };

  useEffect(() => {
    if (!isPlaying && seconds <= 0) {
      return;
    }

    const timer = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          // Stop the timer when seconds reach 0
          setisPlaying(false);
          setShowReset(true);
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);

    // Clean up the timer
    return () => clearInterval(timer);
  }, [isPlaying, seconds]);
  // Format the time
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60)
      .toString()
      .padStart(2, 0);
    const seconds = (timeInSeconds % 60).toString().padStart(2, 0);
    return `${minutes}:${seconds}`;
  };

  // Submit Data
  const handleSubmitData = async () => {
    const payload = {
      name: name,
      mobile_country_code: isdCode,
      mobile: mobile,
      desk_qr_code: qrCode,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}eventregistrationform`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.status == 200 || response.ok) {
        navigate("/registration-thank-you");
      } else if (response.status === 400) {
        showSnackbar("Desk qr code is required", "error");
      } else {
        showSnackbar("Server Error", "error");
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
    }
  };
  return (
    <>
      <AuthWrapper1>
        <Grid
          container
          direction="column"
          justifyContent="flex-end"
          sx={{
            minHeight: "100vh",
            background:
              "linear-gradient(180deg, rgb(255, 246.42, 240.12) 0%, rgba(255, 246.42, 240.12, 0) 100%)",
          }}
        >
          <Grid
            item
            sx={{
              position: "absolute",
              left: 10,
              top: 10,
              // display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <img src="/Siec Logo.png" style={{ width: "200px" }} />
          </Grid>
          <Grid
            item
            sx={{
              position: "absolute",
              right: { md: 50, xl: 200 },
              top: { md: 50, xl: 150 },
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <img src="/dot_shape_2 1 (1).png" style={{ width: "200px" }} />
          </Grid>

          <Grid
            item
            sx={{
              position: "absolute",
              left: { md: 70, xl: 200 },
              bottom: { md: 70, xl: 100 },
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <img src="/line_shape_1 1 (1).png" style={{ width: "200px" }} />
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              direction="column"
              sx={{
                minHeight: "calc(100vh - 68px)",
                m: { xs: 1, sm: 1 },
                mb: 0,
              }}
            >
              <Grid item xs={12} mb={3}>
                <Typography variant="h1">Welcome</Typography>
              </Grid>
              <Grid item sx={{ m: { xs: 1, sm: 1 }, mb: 0 }}>
                <Typography variant="h4" textAlign="center">
                  Take the first step towards an international education
                  experience —{" "}
                  <span style={{ color: "#F8AB1D" }}>
                    your future begins here
                  </span>
                </Typography>
              </Grid>

              <Grid item sx={{ m: { xs: 1, sm: 1 }, mb: 0 }}>
                <Wrapper>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                    padding={2}
                  >
                    <Grid container spacing={2}>
                      {!showOtpcomp ? (
                        <>
                          <Grid item xs={12}>
                            <Typography>
                              Enter Your Name{" "}
                              <span
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  marginLeft: "1px",
                                  fontSize: "1.2em",
                                }}
                              >
                                *
                              </span>
                            </Typography>
                            <TextField
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              size="small"
                              type="text"
                              fullWidth
                              InputProps={{ style: { borderRadius: "10px" } }}
                            />
                          </Grid>
                          <Grid item xs={12} container>
                            <Grid item xs={12}>
                              {" "}
                              <Typography>
                                Enter Mobile No
                                <span
                                  style={{
                                    color: "red",
                                    position: "absolute",
                                    marginLeft: "1px",
                                    fontSize: "1.2em",
                                  }}
                                >
                                  *
                                </span>
                              </Typography>
                            </Grid>
                            <Grid item xs={4} lg={2.5}>
                              <TextField
                                select
                                size="small"
                                fullWidth
                                value={isdCode}
                                onChange={(e) => setIsdCode(e.target.value)}
                                InputProps={{ style: { borderRadius: "10px" } }}
                              >
                                {isdCodeList.map((code) => (
                                  <MenuItem
                                    key={code.phone_code}
                                    value={code.phone_code}
                                  >
                                    +{code.phone_code}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                            <Grid item lg={9.5} xs={8}>
                              <TextField
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                size="small"
                                type="number"
                                fullWidth
                                InputProps={{ style: { borderRadius: "10px" } }}
                              />
                            </Grid>
                          </Grid>

                          <Grid item xs={12} mt={3}>
                            <Button
                              variant="contained"
                              style={{
                                fontSize: "14px",
                                width: "100%",
                                background: "#019E6F",
                                color: "white",
                                borderRadius: "10px",
                              }}
                              onClick={handleGenrateOtp}
                              color="secondary"
                            >
                              Generate OTP
                            </Button>
                          </Grid>
                        </>
                      ) : (
                        <Grid item>
                          <OtpComp
                            setShowOtpComp={setShowOtpComp}
                            mobile={mobile}
                            showotp={showotp}
                            otp={otp}
                            handleOtpChange={handleOtpChange}
                            errors={errors}
                            handleSubmitData={handleSubmitData}
                            title="Submit"
                            setOtp={setOtp}
                            isdCode={isdCode}
                          />
                        </Grid>
                      )}

                      {showOtpcomp && (
                        <>
                          {/* Coundown Timer */}
                          {seconds > 0 && (
                            <Grid item xs={12} mt={3}>
                              <Box
                                sx={{
                                  background: "#d6ecf3",
                                  padding: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {" "}
                                <InfoOutlinedIcon
                                  style={{ color: "#1c96c5" }}
                                  fontSize="small"
                                />
                                <Typography ml={1}>
                                  Your OTP has been sent. You have{" "}
                                  <span
                                    style={{ color: "red", fontWeight: 600 }}
                                  >
                                    {formatTime(seconds)}
                                  </span>{" "}
                                  left to use it.
                                </Typography>
                              </Box>
                            </Grid>
                          )}

                          {showReset && (
                            <Grid item xs={12} textAlign="center" mt={2}>
                              <Typography sx={{ fontSize: "16px" }}>
                                Didn't receive OTP?{" "}
                                <span
                                  style={{
                                    color: "blue",
                                    marginLeft: "5px",
                                    fontWeight: 500,
                                    cursor: "pointer",
                                  }}
                                  onClick={handleGenrateOtp}
                                >
                                  Resend OTP
                                </span>
                              </Typography>
                            </Grid>
                          )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Wrapper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AuthWrapper1>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
